var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    color: _vm.mainTextColor,
  })},[_c('DesktopHeading',{attrs:{"title-text":_vm.desktopTitleText}}),_vm._v(" "),_c('MobileHeading',{attrs:{"title-text":_vm.mobileTitleText}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }